import { Filter } from '../types/filter';
import { FilterItemConfig } from '../types/filter-config';

export type FilterValueSummary =
  | { kind: 'text'; text: string }
  | { kind: 'count'; count: number }
  | null;

/**
 * Summarizes a field filter's value for compact labels (menu bar, chips):
 * single values format via the item's formatter, multi-selections report a count.
 */
export function summarizeFilterValue<T extends object>(
  config: FilterItemConfig<T>,
  filter: Filter<T> | null
): FilterValueSummary {
  if (!filter || filter.type === 'conditions') return null;
  const value = (filter as { value?: unknown }).value;
  if (value === undefined || value === null) return null;
  const format = (v: unknown) => config.formatter(v as never);
  if (Array.isArray(value)) {
    if (value.length === 0) return null;
    if (value.length === 1) return { kind: 'text', text: format(value[0]) };
    return { kind: 'count', count: value.length };
  }
  if (typeof value === 'object' && 'from' in value && 'to' in value) {
    const range = value as { from: unknown; to: unknown };
    return { kind: 'text', text: `${format(range.from)} – ${format(range.to)}` };
  }
  return { kind: 'text', text: format(value) };
}
